// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lx-0";